// src/utils/EncrypUtil.ts

import { publicKeyAdmin, publicKeySdkEncode } from "../services/Macro";
import NodeRSA from 'encrypt-rsa';

const nodeRSA = new NodeRSA();

// 加密/解密工具

class Base64 {
    static encode(str: string): string {
        // return Buffer.from(str).toString('base64');
        return window.btoa(str)
    }

    static decode(str: string): string {
        // return Buffer.from(str, 'base64').toString('utf8');
        return window.atob(str)
    }
}


class EncrypUtil {

    /** 加密请求信息
     * @param data 
     * @returns 
     */
    public encodeRequestBody(data: any) {
        const DEBUG = false
        const TAG = `EncrypUtil.encodeRequestBody() - `
        let params = JSON.stringify(data);
        DEBUG && console.log(TAG, "params:", params);

        let encodeParams = { encode: Base64.encode(params) }
        DEBUG && console.log(TAG, "encode params:", encodeParams);
        return encodeParams
    }

    /** 加密请求信息(RSA)
     * @param data 
     * @returns 
     */
    public async encodeRequestRsa(data: any) {
        const DEBUG = false
        const TAG = `EncrypUtil.encodeRequestRsa() - `
        try {
            let params = JSON.stringify(data);
            DEBUG && console.log(TAG, "params:", params);

            let key = await this.importPublicKey(publicKeyAdmin)
            DEBUG && console.log(TAG, "key:", key);
            let buffer = this.stringToBuffer(params)
            DEBUG && console.log(TAG, "buffer:\n", buffer);
            let encodeData = await this.encryptByRsa(buffer, key)
            DEBUG && console.log(TAG, "encodeData:", encodeData);
            let encodeParams = { encode: encodeData }
            DEBUG && console.log(TAG, "encode params:", encodeParams);
            return encodeParams
        } catch (error) {
            // 如果加密失败，则返回原数据
            console.error(TAG, "加密失败:", error);
            return data
        }
    }

    /** 加密 RequestCode
     * @param data 
     * @returns 
     */
    public async encodeRequestCode(data: any) {
        const DEBUG = true
        const TAG = `EncrypUtil.encodeRequestRsa() - `
        try {
            let params = JSON.stringify(data);
            DEBUG && console.log(TAG, "params:", params);
            // MD5 处理


            let key = await this.importPublicKey(publicKeySdkEncode);
            DEBUG && console.log(TAG, "key:", key);
            let buffer = this.stringToBuffer(params);
            DEBUG && console.log(TAG, "buffer:\n", buffer);
            let encodeData = await this.encryptByRsa(buffer, key);
            DEBUG && console.log(TAG, "encodeData:", encodeData);
            return encodeData;
            // let encodeParams = { encode: encodeData }
            // DEBUG && console.log(TAG, "encode params:", encodeParams);
            // return encodeParams
        } catch (error) {
            // 如果加密失败，则返回原数据
            console.error(TAG, "加密失败:", error);
            return data
        }
    }

    /** 使用 encrypt-rsa 加密字符串.
     * @param text 
     * @param publicKeyPrepare 
     * @param privateKeyPrepare 
     */
    public async encodeWithEncryptRsa(text: string, publicKeyPrepare: string, privateKeyPrepare: string) {
        // 用于生成可用的密钥对
        // const { publicKey, privateKey } = await nodeRSA.createPrivateAndPublicKeys(2048);
        // console.log('publicKey:', publicKey);
        // console.log('privateKey:', privateKey);

        const encrypted = await nodeRSA.encryptStringWithRsaPublicKey({
            text: text,
            publicKey: publicKeyPrepare,
        });
        console.log('Encrypted:', encrypted);

        const decrypted = await nodeRSA.decryptStringWithRsaPrivateKey({
            text: encrypted,
            privateKey: privateKeyPrepare,
        });
        console.log('Decrypted:', decrypted);

        return encrypted;
    }

    /** 使用 encrypt-rsa 解密.
     * @param text 
     * @param privateKeyPrepare 
     */
    public async decodeWithEncryptRsa(encrypted: string, privateKeyPrepare: string) {
        const TAG = `EncrypUtil.decodeWithEncryptRsa() - `;

        const decrypted = await nodeRSA.decryptStringWithRsaPrivateKey({
            text: encrypted,
            privateKey: privateKeyPrepare,
        });
        console.log(TAG, 'Decrypted:', decrypted);

        return decrypted;
    }

    private async importPublicKey(pem: string) {
        const DEBUG = false
        const TAG = `EncrypUtil.importPublicKey() - `
        const binaryKey = Uint8Array.from(atob(pem), (c) => c.charCodeAt(0))
        DEBUG && console.log(TAG, "binaryKey:", binaryKey);
        const importedPublicKey = await crypto.subtle.importKey(
            "spki",
            binaryKey,
            { name: 'RSA-OAEP', hash: { name: "SHA-256" } },
            true,
            ['encrypt']
        )
        DEBUG && console.log(TAG, "importedPublicKey:", importedPublicKey);
        return importedPublicKey
    }

    private async encryptByRsa(message: BufferSource, publicKey: CryptoKey) {
        const DEBUG = false
        const TAG = `EncrypUtil.encryptByRsa() - `
        // 使用Web Crypto API的encrypt()方法对消息进行加密
        const encrypted: ArrayBuffer = await window.crypto.subtle.encrypt(
            {
                name: 'RSA-OAEP' // 加密算法为RSA-OAEP
            },
            publicKey,  // 使用传入的公钥进行加密
            message  // 要加密的消息
        );
        DEBUG && console.log(TAG, "encrypted:", encrypted);
        // 将加密后的数据转换为Base64编码的字符串
        return window.btoa(String.fromCharCode(...new Uint8Array(encrypted)));
        // return Buffer.from(encrypted).toString('base64')
    }

    private stringToBuffer(str: string) {
        const encoder = new TextEncoder();
        const encodedArray = encoder.encode(str);
        return new Uint8Array(encodedArray);
    }

    /** 解密请求信息
     * @param data 
     * @returns 
     */
    public decodeRequestBody(data: any) {
        const DEBUG = false
        const TAG = `EncrypUtil.decodeRequestBody() - `
        let encode = data["encode"]
        if (encode) {
            DEBUG && console.log(TAG, `数据已加密`)
            let decode = Base64.decode(encode)
            return JSON.parse(decode)
        }
        else {
            DEBUG && console.log(TAG, `数据未加密`)
            return data
        }
    }

}

export let encrypUtil = new EncrypUtil()